import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from '@headlessui/react';
import {
  Bars3Icon,
  MagnifyingGlassIcon,
} from '@heroicons/react/24/outline';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { clearPortalSession } from '../../mobile/accountSession';
import { NotificationBell } from '../../mobile/NotificationCenter';
import PacerAuthenticatorButton from './PacerAuthenticatorButton';
import QuickCaseSearchDialog from './QuickCaseSearchDialog';

const accountNavigation = [
  { name: 'Account Management', href: '/account' },
  { name: 'Notifications', href: '/notifications' },
  { name: "Today's ToDos", href: '/todays-todos' },
  { name: '341 Workboard', href: '/341-workboard' },
  { name: 'Reaffirmation Workboard', href: '/reaffirmation-workboard' },
  { name: 'Workout Planner', href: '/workouts' },
];

export default function FirmTopBar({ onOpenSidebar }) {
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);

  const signOut = async () => {
    try {
      await clearPortalSession();
      navigate('/login-firm', { replace: true });
    } catch (error) { window.alert(error.message); }
  };

  return (
    <>
      <div className="sticky top-0 z-40 flex h-16 items-center gap-x-3 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-4">
        <button
          type="button"
          onClick={onOpenSidebar}
          className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
          aria-label="Open navigation"
        >
          <Bars3Icon className="h-6 w-6" />
        </button>

        <button
          type="button"
          onClick={() => setSearchOpen(true)}
          className="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50"
        >
          <MagnifyingGlassIcon className="h-5 w-5 text-indigo-600" aria-hidden="true" />
          <span className="hidden sm:inline">Case Search</span>
        </button>

        <div className="flex flex-1 items-center justify-end gap-x-3 sm:gap-x-4">
          <PacerAuthenticatorButton />
          <NotificationBell />
          <Menu as="div" className="relative">
            <MenuButton className="-m-1.5 flex items-center p-1.5">
              <img
                className="size-8 rounded-full"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReUYvVmScaBWEuSveuW9jEvrplNtpwyau1sg&s"
                alt="Firm account"
              />
              <span className="ml-4 hidden text-sm font-semibold text-gray-900 lg:flex">
                Cisowski Law
              </span>
              <ChevronDownIcon className="ml-2 size-5 text-gray-400" />
            </MenuButton>
            <MenuItems className="absolute right-0 z-50 mt-2.5 w-56 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
              {accountNavigation.map(item => (
                <MenuItem key={item.name}>
                  <a
                    href={item.href}
                    className="block px-4 py-2 text-sm text-gray-900 hover:bg-gray-50"
                  >
                    {item.name}
                  </a>
                </MenuItem>
              ))}
              <div className="my-1 border-t border-gray-100" />
              <MenuItem>
                <button
                  type="button"
                  onClick={signOut}
                  className="block w-full px-4 py-2 text-left text-sm text-red-700 hover:bg-red-50"
                >
                  Sign out
                </button>
              </MenuItem>
            </MenuItems>
          </Menu>
        </div>
      </div>

      <QuickCaseSearchDialog open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}
